import { strings } from "../../../strings/strings";

export const isRtlLanguage = (langName) => {
  if (!langName) return false;
  const v = String(langName).trim();
  return /^ar$/i.test(v) || /arab/i.test(v) || /[\u0600-\u06FF]/.test(v);
};

export const validateKey = (key) => {
  if (!key) return "";
  const keyPattern = /^[A-Za-z0-9_]+$/;
  if (!keyPattern.test(key)) return strings.invalidKeyformat;
  return "";
};

export const removeQuotes = (str) => (str ? str.replace(/^"|"$/g, "") : "");

export const getErrorMessage = (err) => err?.message || err?.response?.data?.message;

